
import BlogTextColor from '~/components/Common/Blog/BlogTextColor'

export default {
    name: 'Japan',
    components: { BlogTextColor },
}
